import React from 'react';
import NotFound from '../../../components/Errors/NotFound';

const NotFoundPage = () => {
  return <NotFound />;
};

export default NotFoundPage;
